import * as validators from '@vuelidate/validators'
import i18n from '@/i18n'

const { createI18nMessage } = validators
const { t } = i18n.global || i18n
const withI18nMessage = createI18nMessage({ t })

const customRequired = (value: any, siblingValues?: any, instance?: any) => {
    if (Array.isArray(value)) {
        return value.length > 0; // Tablica jest wymagana i nie może być pusta
    }
    return validators.required.$validator(value, siblingValues, instance); // Standardowa walidacja dla innych typów
};

// Użycie z i18n
export const required = withI18nMessage({
    $validator: customRequired,
    $message: t('validation.required') || 'Pole jest wymagane',
});
//export const required = withI18nMessage(validators.required)
export const requiredIf = (prop: boolean | string | (() => boolean | Promise<boolean>)): any => withI18nMessage(validators.requiredIf(prop))
export const minLength = withI18nMessage(validators.minLength, { withArguments: true })
export const email = withI18nMessage(validators.email)
export const maxLength = withI18nMessage(validators.maxLength, { withArguments: true })
export const minValue = withI18nMessage(validators.minValue, { withArguments: true })
export const maxValue = withI18nMessage(validators.maxValue, { withArguments: true })
export const numeric = withI18nMessage(validators.numeric)
export const decimal = withI18nMessage(validators.decimal)